import { Checkbox } from "@newsela/angelou";
import PropTypes from "prop-types";

import { TEACHING_LANGUAGES } from "./TeacherLanguageSelector.constants";
import {
  containerCss,
  listCss,
  checkboxCss,
} from "./TeacherLanguageSelector.style";

const propTypes = {
  disabled: PropTypes.bool,
  onClick: PropTypes.func.isRequired,
  languages: PropTypes.arrayOf(PropTypes.string),
  title: PropTypes.string.isRequired,
};

const defaultProps = {
  languages: [],
};

const TeacherLanguageSelector = ({ disabled, onClick, languages, title }) => {
  const renderLanguageCheckbox = ([key, name]) => {
    const checked = languages.includes(key);

    return (
      <Checkbox
        key={key}
        label={name}
        name={name}
        value={key}
        checked={checked}
        disabled={disabled}
        onClick={() => onClick(key, !checked, name)}
        __cssFor={checkboxCss}
      />
    );
  };

  return (
    <fieldset css={containerCss}>
      <legend>{title}</legend>
      <div css={listCss}>
        {Object.entries(TEACHING_LANGUAGES).map(renderLanguageCheckbox)}
      </div>
    </fieldset>
  );
};

TeacherLanguageSelector.propTypes = propTypes;
TeacherLanguageSelector.defaultProps = defaultProps;

export default TeacherLanguageSelector;
